export default __webpack_public_path__ + "static/media/Mako.05465241.png";